import { render } from "./QuestionSectionScoreContentCreateEditFormComponent.vue?vue&type=template&id=fb01e1b2"
import script from "./QuestionSectionScoreContentCreateEditFormComponent.vue?vue&type=script&lang=js"
export * from "./QuestionSectionScoreContentCreateEditFormComponent.vue?vue&type=script&lang=js"

import exportComponent from "/tmp/build_905a1b4c/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__